var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2139ae99-2df1-477e-ae58-1711445dad33",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.2 71.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.33,6.18c-3.8-3.99-8.85-6.18-14.24-6.18s-10.44,2.2-14.24,6.18l-5.26,5.52-5.26-5.52C30.54,2.2,25.49,0,20.1,0S9.67,2.2,5.87,6.18C-1.96,14.38-1.96,27.73,5.87,35.94l33.73,35.38,33.73-35.38c7.82-8.2,7.82-21.55,0-29.76Zm-33.73,60.4L8.21,33.65C1.58,26.71,1.58,15.41,8.21,8.47c3.18-3.34,7.41-5.18,11.9-5.18s8.72,1.84,11.9,5.18l7.6,7.97,7.6-7.97c3.18-3.34,7.41-5.18,11.9-5.18s8.72,1.84,11.9,5.18c6.62,6.94,6.62,18.24,0,25.19l-31.39,32.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeSelection);
export default __webpack_public_path__ + "static/media/simple filigree - selection.7be971302782e9d31be119b172fcf221.svg";
export { ForwardRef as ReactComponent };